module.exports = __webpack_public_path__ + "img/LTS_fullcolour_ENG.081d94ad.png";